export default {
  methods: {
    notifyStoreSuccess(message) { // update_success_message, delete_success_message
      this.$notify({
        group: 'store_notifications',
        type: 'success',
        text: message || this.$t('booleanSearch.search_create_success_message')
      })
    },
    notifyStoreError(message) {
      this.$notify({
        group: 'store_notifications',
        type: 'error',
        text: message || this.$t('messages.request.error')
      })
    },
  }
}